import React, { useMemo } from 'react';
import { useAsyncFn } from 'react-use';
import { Redirect } from 'react-router-dom';

import { __t } from '@mssgme/shared';
import { useNavigationUtils } from '@mssgme/hooks';
import { useFrontAPI, useSavedOrders } from '../../../hooks';
import { printPrice } from '../../printPrice';
import { Row } from '../../Row';
import { OrderItemsList } from '../../OrderItem';
import { StepsFooter } from './StepsFooter';

function AdjustingStep() {
    const { generateUrl } = useNavigationUtils({ useMatchUrl: false });
    const { currentOrder, removeOrderId } = useSavedOrders();
    const backPath = useMemo(() => generateUrl('../..'), []);
    const api = useFrontAPI();
    const orderId = currentOrder?._id || null;

    const [{ loading }, handleModifyItems] = useAsyncFn(
        /** @param {{ productId: string, quantity: number }[]} items Order items */
        async (items) => {
            const order = await api.orders.modify({
                orderId,
                payload: {
                    items,
                },
            });

            if (!order.items.length) {
                // todo: in the future, change the logic:
                // after last order item count brought to 0 - disable 'Next' button, but do not remove the order yet;
                // if the modal is closed, but order items count still 0 - delete the order entirely
                removeOrderId(order._id);
            }
        },
        [orderId]
    );

    if (!currentOrder) {
        return orderId ? null : <Redirect to={backPath} />;
    }

    return (
        <div>
            <OrderItemsList order={currentOrder} onAdjust={currentOrder.finalized ? undefined : handleModifyItems} />
            <Row label={__t('total_to_pay')} value={printPrice(currentOrder.total)} />

            <StepsFooter next disabled={loading} />
        </div>
    );
}

export default AdjustingStep;
